import { UserType } from 'library/ts/model/user/UserType';
import { PlayerAdapterEvent } from 'library/ts/player/adapter/events/PlayerAdapterEvent';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagErrorCode } from 'tag/ts/tag/model/error/TagErrorCode';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
export class AdBlockerManager extends AbstractTagClass {
    #timeoutId;
    constructor(argument) {
        super({
            ...argument,
            name: 'AdBlockerManager'
        });
        const adSDKType = this.tag?.model?.adUtilities?.adSetupInfo()?.sdk?.type;
        this.utils.Delay.delay()
            .then(() => {
            if ((adSDKType === AdSDK.IMA
                ||
                    adSDKType === AdSDK.IMA_DAI)
                &&
                    this.#adBlockParamsValid() === true) {
                this.#initEventHandler();
            }
        });
    }
    #adBlockParamsValid = () => {
        return this.utils.Type.isFunction(this.params?.AD?.AB?.method) === true &&
            this.utils.Type.isNullOrUndefined(this.params?.AD?.AB?.interval) === false;
    };
    #initEventHandler = () => {
        this.tagEventsHandler(this.#onTagEvent, [
            TagEvent.ON_AD_BLOCKER_DETECTED,
            TagEvent.ON_PLAYER_EVENT,
            TagEvent.ON_FATAL_ERROR,
            TagEvent.ON_REQUEST_AD_BLOCKER_CHECK_STOP
        ]);
    };
    #startCheckTimeout = () => {
        this.#stopCheckTimeout();
        this.#timeoutId = setTimeout(this.#checkAdblockStatus, this.params.AD.AB.interval);
    };
    #stopCheckTimeout = () => {
        clearTimeout(this.#timeoutId);
    };
    #checkAdblockStatus = () => {
        const detected = this.params.AD.AB.method();
        this?.logger?.log('checkAdblockStatus:', 'ad blocker check on page result:', detected);
        switch (detected) {
            case true:
                this.#emitAdblockerDetected();
                break;
            case false:
                this.#startCheckTimeout();
                break;
        }
    };
    #emitAdblockerDetected = () => {
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_AD_BLOCKER_DETECTED, this.tag));
    };
    #onTagEvent = (event) => {
        const logEvent = (event) => {
            this?.logger?.log('#onTagEvent', event);
        };
        switch (event?.type) {
            case TagEvent.ON_PLAYER_EVENT:
                this.#onPlayerEvent(event?.data?.playerAdapterEvent);
                break;
            case TagEvent.ON_AD_BLOCKER_DETECTED:
                logEvent(event);
                this.#onAdblockDetected();
                break;
            case TagEvent.ON_FATAL_ERROR:
                logEvent(event);
                this.#onFatalError();
                break;
            case TagEvent.ON_REQUEST_AD_BLOCKER_CHECK_STOP:
                logEvent(event);
                this.#onRequestAdBlockerCheckStop();
                break;
        }
    };
    #onPlayerEvent = (event) => {
        switch (event?.type) {
            case PlayerAdapterEvent.RESOURCE_START:
                const userTypeString = this.tag.tagUtilities.getUserType(this?.params?.USER?.userStatus);
                switch (userTypeString) {
                    case UserType.ANON:
                    case UserType.LC:
                    case UserType.LCP:
                    case UserType.MVPD_AUTHZ:
                        this.utils.Delay.delay(this.params.AD.AB.delay)
                            .then(() => this.#startCheckTimeout());
                        break;
                }
                break;
            case PlayerAdapterEvent.RESOURCE_END:
                this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_REQUEST_AD_BLOCKER_CHECK_STOP, this.tag, undefined, this, this.name));
                break;
        }
    };
    #onAdblockDetected = () => {
        this?.logger?.log('onAdblockDetected');
        this.#stopCheckTimeout();
        this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_TAG_PLAYER_STOP_REQUEST, this?.tag, undefined, this, this?.name));
        let errorCode;
        const userTypeString = this.tag.tagUtilities.getUserType(this?.params?.USER?.userStatus);
        switch (userTypeString) {
            case UserType.ANON:
                errorCode = TagErrorCode.AD_BLOCKER_CBS_ANON_USER;
                break;
            case UserType.LC:
            case UserType.LCP:
            case UserType.MVPD_AUTHZ:
                errorCode = TagErrorCode.AD_BLOCKER_CBS_LC_USER;
                break;
        }
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_FATAL_ERROR, this.tag, {
            fatalError: {
                code: errorCode,
                msg: {
                    original: undefined,
                    custom: this.tag.errorManager.createErrorMessageByCode(errorCode)
                }
            }
        }));
    };
    #onFatalError = () => {
        this?.logger?.log('onFatalError');
        this.#stopCheckTimeout();
    };
    #onRequestAdBlockerCheckStop = () => {
        this?.logger?.log('onRequestAdBlockerCheckStop');
        this.#stopCheckTimeout();
    };
}
